import Image from "next/image";
import Link from "next/link";

type PastTourCardProps = {
  slug: string | undefined;
  image?: {
    url: string;
    thumbs?: {
      sm?: string;
    };
  };
  title: string;
  description: string;
  tag?: string;
  days?: string;
  date?: unknown;
};

export default function PastTourCard({
  slug,
  image,
  title,
  description,
}: PastTourCardProps) {
  return (
    <Link href={`/spomienky/${slug}`} passHref>
      <div className='relative w-full max-w-88.75 rounded-xl overflow-hidden shadow-lg cursor-pointer group'>
        <div className='relative w-100 h-50 overflow-hidden'>
          {(image?.thumbs?.sm || image?.url) && (
            <Image
              src={image?.thumbs?.sm ?? image!.url}
              alt='Past tour cover photo'
              width={400}
              height={200}
              className='object-cover w-full h-full transition-transform duration-300 group-hover:scale-105'
              unoptimized
            />
          )}
          <div className='absolute inset-0 bg-black opacity-50 transition-opacity duration-300 group-hover:opacity-40'></div>
        </div>

        <div className='absolute inset-0 flex flex-col items-center justify-center px-4'>
          <h2 className='text-white font-bold text-lg text-center'>{title}</h2>
          <p className='text-sm text-gray-300 text-center'>{description}</p>
        </div>
      </div>
    </Link>
  );
}
